import React from "react";
import { COMPULSORY_CREDIT_PRODUCT_FIELDS, loanApplicationFormInputs, LOANS_WITH_TABLE_DATA } from "../CreateLoan/CreateLoanConstants";
import { Button, Col, Row } from "react-bootstrap";
import { Strings } from "../../resources/i18n/i18n";
import TextFieldComponent from "../CustomUIComponents/TextFieldComponent/TextFieldComponent";
import Utility from "../../utils/Utility";
import moment from "moment";
import { LOAN_TYPES } from "../AnalystApproval/Constants";
import { FREQUENCIES, WEEKLY_SIX_DAYS } from "../LoanDetails/Constants";
import _ from "lodash";
import { LOAN_APPLICATION_FORM_FILLED, LOAN_APPLICATION_STATUS } from "../../constants/appConstants";
import { NumericFormat } from "react-number-format";
class CreditProduct extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            errorMessage: this.props.errorMessage,
            errorFieldArray: [],
            creditProductDropdownLists: {
                businessNameList: this.props.businessNameList,
                disbursementTypeList: this.props.disbursementTypeList,
                transferAccountTypeList: this.props.transferAccountTypeList,
                bankNameList: this.props.bankDetails,
                accountTypeList: [],
                frequencyList: this.props.frequencyList,
                termsArrayList: this.props.termsArray,
                collectionDaysList: this.props.collectionDaysList,
            },
            creditProduct: {
                amount: this.props.EMIAmount ? this.props.EMIAmount : this.props.creditProductInputDataForEdit?.amount || (!(this.props.isDisbursed) && this.props.hasExistingLoan) ? this.props.loanInfo?.amountRequested : null,
                businessName: this.props.creditProductInputDataForEdit?.businessName || (!(this.props.isDisbursed) && this.props.hasExistingLoan) ? this.props.loanInfo.supplierDetails?.businessName : null,
                selectedDisbursementType: this.props.creditProductInputDataForEdit?.selectedDisbursementType || (!(this.props.isDisbursed) && this.props.hasExistingLoan) ? this.props.loanInfo.selectedDisbursementType : null,
                selectedTransferAccountType: this.props.creditProductInputDataForEdit?.selectedTransferAccountType || (!(this.props.isDisbursed) && this.props.hasExistingLoan) ? this.props.loanInfo.selectedTransferAccountType : null,
                accountType: this.props.creditProductInputDataForEdit?.accountType || (!(this.props.isDisbursed) && this.props.hasExistingLoan) ? this.props.loanInfo.accountInfo?.accountType : null,
                bankName: this.props.creditProductInputDataForEdit?.bankName || (!(this.props.isDisbursed) && this.props.hasExistingLoan) ? this.props.loanInfo.accountInfo?.bankName : null,
                accountNumber: this.props.creditProductInputDataForEdit?.accountNumber || (!(this.props.isDisbursed) && this.props.hasExistingLoan) ? this.props.loanInfo.accountInfo?.accountNumber : null,
                frequency: this.props.creditProductInputDataForEdit?.frequency || ((!this.props.isDisbursed) && this.props.hasExistingLoan) ? this.props.loanInfo.frequency : null,
                collectionDays: this.props.creditProductInputDataForEdit?.collectionDays || (!(this.props.isDisbursed) && this.props.hasExistingLoan) ? this.props.loanInfo.collectionDays : null,
                term: this.props.creditProductInputDataForEdit?.term || (!(this.props.isDisbursed) && this.props.hasExistingLoan) ? this.props.loanInfo.termRequested : null,
                calculatedEMIData: (!(this.props.isDisbursed) && this.props.hasExistingLoan) ? this.props.calculatedEMIData : null,
            },
        };
    }
    componentDidUpdate(prevProps, prevState) {
        if (!_.isEqual(prevProps.businessNameList, this.props.businessNameList)) {
            this.setState(prevState => ({
                creditProductDropdownLists: {
                    ...prevState.creditProductDropdownLists,
                    businessNameList: this.props.businessNameList
                }
            }));
        }

        if (!_.isEqual(prevProps.disbursementTypeList, this.props.disbursementTypeList)) {
            this.setState(prevState => ({
                creditProductDropdownLists: {
                    ...prevState.creditProductDropdownLists,
                    disbursementTypeList: this.props.disbursementTypeList
                }
            }));
        }

        if (!_.isEqual(prevProps.transferAccountTypeList, this.props.transferAccountTypeList)) {
            this.setState(prevState => ({
                creditProductDropdownLists: {
                    ...prevState.creditProductDropdownLists,
                    transferAccountTypeList: this.props.transferAccountTypeList
                }
            }));
        }

        if (!_.isEqual(prevProps.frequencyList, this.props.frequencyList)) {
            this.setState(prevState => ({
                creditProductDropdownLists: {
                    ...prevState.creditProductDropdownLists,
                    frequencyList: this.props.frequencyList
                }
            }));
        }

        if (!_.isEqual(prevProps.termsArray, this.props.termsArray)) {
            this.setState(prevState => ({
                creditProductDropdownLists: {
                    ...prevState.creditProductDropdownLists,
                    termsArrayList: this.props.termsArray
                }
            }));
        }

        if (!_.isEqual(prevProps.collectionDaysList, this.props.collectionDaysList)) {
            this.setState(prevState => ({
                creditProductDropdownLists: {
                    ...prevState.creditProductDropdownLists,
                    collectionDaysList: this.props.collectionDaysList
                }
            }));
        }
        if (!_.isEqual(prevProps.errorMessage, this.props.errorMessage)) {
            this.setState({
                errorMessage: this.props.errorMessage
            });
        }
        if (!_.isEqual(prevProps.bankDetails, this.props.bankDetails)) {
            const mappedBankDetails = this.props.bankDetails.map(item => ({
                value: item.bn,
                name: item.bn
            }));
            this.setState(prevState => ({
                creditProductDropdownLists: {
                    ...prevState.creditProductDropdownLists,
                    bankNameList: mappedBankDetails
                }
            }), () => {
                if (this.props.loanApplicationDetails !== null) {
                    this.assignBanckAccountTypeList();
                }
            });
        }
    }



    componentDidMount() {
        if (this.props.selectedLoanType === LOAN_TYPES.EXTERNAL_FACTORING) {
            this.props.getSupplierDetails();
            this.props.getDropdownValuesForSupplierForm();
            this.props.getBankDetails();
        } else if (this.props.selectedLoanType === LOAN_TYPES.PERSONAL_LOAN) {
            this.props.getDropdownValuesForSupplierForm();
            this.props.getBankDetails();
        }
        if (this.state.creditProduct.amount && this.state.creditProduct.frequency) {
            this.getFrequencyDropDownList();
            this.props.getPossibleCollectionCycles({ fr: this.state.creditProduct["frequency"] });
            this.props.assignTermsAndrateAction({ amount: this.state.creditProduct["amount"], frequency: this.state.creditProduct["frequency"] });
            if (this.state.creditProduct.term) {
                this.calculateEMI()
            }
        }
    }
    getFrequencyDropDownList = () => {
        const request = {
            loanType: this.props.selectedLoanType,
            amount: this.state.creditProduct["amount"],
            level: this.props.minimartDetails.creditLimit.eligibility,
            minimartId: this.props.minimartDetails.minimartDetails.id,
        }
        this.props.getFrequencyList(request);

    }
    handleOnSelectClick = (event) => {

        let key = event.target.name || event.currentTarget.name;
        let eventTargetName = event.target.tagName || event.currentTarget.tagName;
        if (key === "frequency" && (eventTargetName === "OPTION" || eventTargetName === "SELECT")) {
            this.getFrequencyDropDownList();
        }
    }

    renderNumberTextFields = (prop) => {
        let errorClass = this.state.errorFieldArray?.includes(prop.name) ? " error-data" : "";
        let disableTextField = this.props.disableTextField || this.props.loanInfo?.prefillData;
        if (prop.name === "amount" && LOANS_WITH_TABLE_DATA.includes(this.props.selectedLoanType)) {
            disableTextField = true;
        }
        if (this.props.applyLoanConfig.loanStatus === LOAN_APPLICATION_STATUS.created) {
            disableTextField = true;
        }
        return (
            <div className={`textFieldComponent ${errorClass}`}>
                <NumericFormat
                    name={prop.name}
                    className={"form-control w-100"}
                    onValueChange={(event) => {
                        const target = {
                            name: prop.name,
                            value: event.value ? event.value : "",
                        };
                        prop.handleChange({ target });
                    }}
                    allowLeadingZeros
                    value={this.state.creditProduct[prop.name]}
                    type='text'
                    placeholder={Strings(prop.label)}
                    allowNegative={false}
                    disabled={prop.disabled || this.props.disableTextField || disableTextField}
                    isAllowed={
                        prop.isAllowed
                            ? prop.isAllowed
                            : () => {
                                return true;
                            }
                    }
                    maxLength={prop.maxLength}
                />
            </div>
        );
    };
    renderTextField = (prop) => {

        let onKeyDown;
        let disableTextField = this.props.disableTextField || this.props.loanInfo?.prefillData;
        let errorClass = this.state.errorFieldArray?.includes(prop.name) ? " error-data" : "";
        let dropDownList = prop.dropDownList;

        if ((!this.state.creditProduct?.amount) && (prop.name === "term" || prop.name === "frequency")) {
            disableTextField = true;
        }
        if (this.props.applyLoanConfig.loanStatus === LOAN_APPLICATION_STATUS.created) {
            disableTextField = true;
        }
        if (prop.type === "number") {
            return this.renderNumberTextFields(prop);
        } else {
            onKeyDown = () => { };
            return (
                <div className={`textFieldComponent ${errorClass}`}>
                    <TextFieldComponent
                        id={prop.name}
                        type={prop.type}
                        handleChange={(event) => prop.handleChange(event)}
                        value={prop.value}
                        multiple={false}
                        halfWidth={false}
                        placeholder={Strings(prop.label)}
                        name={prop.name}
                        onKeyDown={onKeyDown}
                        disabled={disableTextField}
                        onClick={(event) => { this.handleOnSelectClick(event) }}
                    >
                        {prop.isSelection && (
                            <>
                                <option value="">{Strings(prop.label)}</option>
                                {Array.isArray(dropDownList) && dropDownList.map((version) => {
                                    return (
                                        <option
                                            key={version.value || version}
                                            value={version.value || version}
                                        >
                                            {Strings(version.name) || Strings(version.label) || Strings(version.bn) || Strings(version)}
                                        </option>
                                    );
                                })}
                            </>
                        )}
                    </TextFieldComponent>
                </div>
            );
        }
    };
    assignBanckAccountTypeList = (bank) => {
        let accountTypeList = [...(this.state.creditProductDropdownLists.accountTypeList || [])];
        let bankName = !bank ? this.props.loanInfo?.accountInfo?.bankName : bank;
        const selectedBank = this.props.bankDetails.find(
            (bank) => bank.bn === bankName
        );
        if (selectedBank) {
            selectedBank.ad.forEach((acc) => {
                accountTypeList.push(acc.at);
            });
        }
        this.setState(prevState => ({
            creditProductDropdownLists: {
                ...prevState.creditProductDropdownLists,
                accountTypeList: accountTypeList
            }
        }));
    };
    handleFieldChange = (event) => {
        const { name, value } = event.target;
        this.setState(prevState => ({
            errorFieldArray: prevState.errorFieldArray?.filter(field => field !== name) || [],
        }));

        this.setState((prevState) => {
            let updatedCreditProduct = {
                ...prevState.creditProduct,
                [name]: value,
            };
            if (this.state.errorFieldArray?.length === 0) {
                this.setState({
                    errorMessage: ""
                })
            }
            if (name === "bankName") {
                this.assignBanckAccountTypeList(value)
            }
            const bankFields = ["bankName", "accountType", "accountNumber"];
            if (name === "selectedDisbursementType") {
                if (value !== "TRANSFER") {
                    updatedCreditProduct.selectedTransferAccountType = "";
                }
            }
            if (name === "selectedTransferAccountType") {
                if (value !== "PERSONAL_ACCOUNT") {
                    bankFields.forEach(field => {
                        updatedCreditProduct[field] = "";
                    });
                }
            }

            if (name === "amount") {
                updatedCreditProduct = {
                    ...updatedCreditProduct,
                    amount: value,
                    frequency: "",
                    term: "",
                    collectionDays: "",
                };
            } else if (name === "collectionDays") {
                updatedCreditProduct = {
                    ...updatedCreditProduct,
                    term: "",
                    collectionDays: value,
                    calculatedEMIData: {}
                };
            }

            else if (name === "frequency") {
                updatedCreditProduct = {
                    ...updatedCreditProduct,
                    frequency: value,
                    term: "",
                    collectionDays: value === FREQUENCIES.WEEKLY_SIX ? WEEKLY_SIX_DAYS : value,
                    calculatedEMIData: {}
                };
                this.props.assignTermsAndrateAction(updatedCreditProduct);
            } else if (name === "term" || name === "collectionDays") {
                updatedCreditProduct[name] = value;
            }

            return {
                creditProduct: {
                    ...updatedCreditProduct,
                },
            };
        }, () => {
            if (name === "frequency" && this.state.creditProduct.frequency && this.state.creditProduct.frequency !== FREQUENCIES.WEEKLY_SIX) {
                this.props.getPossibleCollectionCycles({ fr: this.state.creditProduct["frequency"] });
            }
            if (name === "term") {
                this.calculateEMI();
            }
        });
    };

    checkInputs = () => {
        let valid = true;
        if (
            !this.state.creditProduct.amount ||
            !this.state.creditProduct.term ||
            !this.state.creditProduct.frequency ||
            (!this.state.creditProduct.collectionDays) ||
            (this.state.creditProduct?.term === Strings("termsUnavailable")) ||
            this.state.creditProductDropdownLists.termsArrayList[0]?.toString() === "-1"
        ) {
            valid = false;
        }
        return valid;
    };
    calculateEMI = () => {
        let valid = this.checkInputs();
        if (!valid) {
            this.setState({
                errorMessage: Strings("pleaseSelectCorrectCalculationData")
            })
        } else {
            let request = {
                minimartId: this.props.minimartDetails.minimartDetails.id,
                loanType: this.props.selectedLoanType,
                term: this.state.creditProduct["term"],
                amount: this.state.creditProduct["amount"],
                frequency: this.state.creditProduct["frequency"],
                collectionDays: this.state.creditProduct["collectionDays"],
            }
            this.props.calculateEMICall(request);
        }
    }
    shouldRenderField = (fieldKey) => {
        const loanType = this.props.selectedLoanType;
        const {
            selectedDisbursementType,
            selectedTransferAccountType
        } = this.state.creditProduct;

        const isDisbursementLoanType = loanType === LOAN_TYPES.EXTERNAL_FACTORING || loanType === LOAN_TYPES.PERSONAL_LOAN;

        if (!isDisbursementLoanType) return true;

        if (fieldKey === "businessName") return loanType === LOAN_TYPES.EXTERNAL_FACTORING;

        if (fieldKey === "selectedDisbursementType") return true;

        if (fieldKey === "selectedTransferAccountType") {
            return selectedDisbursementType === "TRANSFER";
        }
        const bankFields = ["bankName", "accountType", "accountNumber"];
        if (bankFields.includes(fieldKey)) {
            return selectedDisbursementType === "TRANSFER" && selectedTransferAccountType === "PERSONAL_ACCOUNT";
        }

        return true;
    };

    renderCreditProducts = () => {
        const selectedLoanType = this.props.selectedLoanType;
        return loanApplicationFormInputs.creditProduct
            .filter((inputField) => {
                return (
                    inputField.visibleForLoanTypes.includes(selectedLoanType) &&
                    this.shouldRenderField(inputField.key)
                );
            })
            .map((inputField) => {
                const value = this.state.creditProduct[inputField.key] || "";
                let dropDownList = this.state.creditProductDropdownLists[inputField.dropdownListKey];
                // PERSONAL_LOAN has no supplier, so SUPPLIER_ACCOUNT is not a valid transfer target.
                if (inputField.key === "selectedTransferAccountType" && selectedLoanType === LOAN_TYPES.PERSONAL_LOAN) {
                    dropDownList = (dropDownList || []).filter((opt) => (opt?.value || opt) !== "SUPPLIER_ACCOUNT");
                }
                return (
                    <>
                        {!(this.state.creditProduct?.frequency === FREQUENCIES.WEEKLY_SIX && inputField.key === "collectionDays") &&
                                <Col md={4} key={inputField.key} className="p-0 pb-3">
                                <Row style={{ display: 'flex' }}>
                                <span className="w-auto pe-0">{Strings(inputField.label)}</span>
                                <span className="mandatoryFields w-auto ps-0">*</span>
                            </Row>
                            <Row>
                                <Col md={10} className="pt-2">
                                    {this.renderTextField({
                                        label: inputField.label,
                                        name: inputField.key,
                                        type: inputField.type,
                                        value: value,
                                        isSelection: inputField.isSelection,
                                        isNumber: inputField.isNumber,
                                        dropDownList: dropDownList,
                                        handleChange: this.handleFieldChange,
                                    })}
                                </Col>
                            </Row>
                        </Col>}
                    </>
                );
            });
    };
    renderCalculatedEMI = () => {
        return <Col md={12}>
            <Row>
                <Col md={12} className='ps-0 '>
                    <div className='subHeadingText ps-0'>
                        {Strings("EMICollection")}<span>
                        </span>
                    </div>
                </Col>
            </Row>
            <Row>
                {/* Labels Row */}
                <Col md={3} className='ps-0'>
                    <div className='subHeadingText pt-2'>
                        {Strings("FromDate")}
                    </div>
                </Col>
                <Col md={3}>
                    <div className='subHeadingText pt-2'>
                        {Strings("ToDate")}<span></span>
                    </div>
                </Col>
                <Col md={3} className='ps-0'>
                    <div className='subHeadingText pt-2'>
                        {Strings("emiAmount")}
                    </div>
                </Col>
                <Col md={3}>
                    <div className='subHeadingText pt-2'>
                        {Strings("noOfEmi")}<span></span>
                    </div>
                </Col>

                {/* Values Row */}
                <Col md={3} className='ps-0'>
                    <div className='subText' title={Strings("FromDate")}>
                        {this.props.calculatedEMIData?.period ?
                            moment.utc(
                                this.props.calculatedEMIData.period.start
                            ).format("dddd, ll") : Strings("NA")}
                    </div>
                </Col>
                <Col md={3}>
                    <div className='subText' title={Strings("ToDate")}>
                        {this.props.calculatedEMIData?.period
                            ? moment.utc(this.props.calculatedEMIData.period.end).format("dddd, ll")
                            : Strings("NA")}
                    </div>
                </Col>
                <Col md={3} className='ps-0'>
                    <div className='subText w-auto' title={Strings("emiAmount")}>
                        {this.props.calculatedEMIData?.emi
                            ? "$" +
                            Utility.getCurrencyRepresentationOfAmount(
                                this.props.calculatedEMIData.emi
                            )
                            : Strings("NA")}
                    </div>
                </Col>
                <Col md={3}>
                    <div className='subText' title={Strings("noOfEmi")}>
                        {this.state.creditProduct?.term
                            ? Strings(this.state.creditProduct.term)
                            : Strings("NA")}
                    </div>
                </Col>
            </Row>
        </Col>
    }
    createLoan = () => {
        let requestData = {};
        let loanInfo = {
            amountRequested: this.state.creditProduct.amount,
            collectionDays: this.state.creditProduct.collectionDays,
            emi: this.props.calculatedEMIData.emi,
            frequency: this.state.creditProduct.frequency,
            termRequested: this.state.creditProduct.term,
            type: this.props.selectedLoanType,
        }

        if (this.props.selectedLoanType === LOAN_TYPES.EXTERNAL_FACTORING) {
            const businessNameToFind = this.state.creditProduct.businessName
            const matchingSupplier = this.props.businessNameList.find(supplier =>
                supplier.name === businessNameToFind
            );
            const supplierId = matchingSupplier ? matchingSupplier.supplierId : null;
            let accountInfo = {
                accountNumber: this.state.creditProduct.accountNumber ? this.state.creditProduct.accountNumber : "",
                accountType: this.state.creditProduct.accountType ? this.state.creditProduct.accountType : "",
                bankName: this.state.creditProduct.bankName ? this.state.creditProduct.bankName : "",
            }
            requestData = {
                ...loanInfo,
                selectedDisbursementType: this.state.creditProduct.selectedDisbursementType,
                selectedTransferAccountType: this.state.creditProduct.selectedDisbursementType === 'TRANSFER' ? this.state.creditProduct.selectedTransferAccountType : undefined,
                supplierId: supplierId,
                accountInfo: this.state.creditProduct.selectedDisbursementType === 'TRANSFER' ? accountInfo : null,
            }
        }
        else if (this.props.selectedLoanType === LOAN_TYPES.CONSUMER) {
            requestData = {
                ...loanInfo,
                productRef: this.props.selectedRecordDetails.id,
            }
        }
        else if (this.props.selectedLoanType === LOAN_TYPES.MOTORCYCLE_LOAN) {
            requestData = {
                ...loanInfo,
                productRef: this.props.selectedRecordDetails.id,
                productCost: this.props.selectedRecordDetails.co,
            }
        }
        else if (this.props.selectedLoanType === LOAN_TYPES.FACTORING) {
            requestData = {
                ...loanInfo,
                invoiceNumber: this.props.selectedRecordDetails.number,
            }
        }
        else if (this.props.selectedLoanType === LOAN_TYPES.PERSONAL_LOAN) {
            let accountInfo = {
                accountNumber: this.state.creditProduct.accountNumber ? this.state.creditProduct.accountNumber : "",
                accountType: this.state.creditProduct.accountType ? this.state.creditProduct.accountType : "",
                bankName: this.state.creditProduct.bankName ? this.state.creditProduct.bankName : "",
            }
            requestData = {
                ...loanInfo,
                selectedDisbursementType: this.state.creditProduct.selectedDisbursementType,
                selectedTransferAccountType: this.state.creditProduct.selectedDisbursementType === 'TRANSFER' ? this.state.creditProduct.selectedTransferAccountType : undefined,
                accountInfo: this.state.creditProduct.selectedDisbursementType === 'TRANSFER' ? accountInfo : null,
            }
        }
        else {
            requestData = loanInfo
        }
        let requestObject = {
            minimartId: this.props.minimartDetails.minimartDetails.id,
            loanInfo: requestData,
            suggestedAmount: this.props.suggestedAmount,
        }
        this.props.createLoan(requestObject, this.state.creditProduct, (errorMessage) => {
            this.setState({ errorMessage: errorMessage });
        });
    }
    validateData = () => {

        if (this.props.existingLoanDetails?.st !== LOAN_APPLICATION_STATUS.disbursed && ((this.props.existingLoanDetails?.tp === this.props.selectedLoanType) || this.props.loanInfo?.prefillData)) {
            this.props.goNext();
            return;
        }
        const { selectedLoanType } = this.props;
        const errors = [];
        let errorMessages = "";
        const alwaysRequiredFields = COMPULSORY_CREDIT_PRODUCT_FIELDS;

        alwaysRequiredFields.forEach((key) => {
            const value = this.state.creditProduct[key];
            const isEmpty = value === undefined || value === null || value === "";
            if (isEmpty) {
                errors.push(key);
                if (key === "amount") {
                    errorMessages = Strings("pleaseSelectRequiredFields");
                }
            }
        });
        loanApplicationFormInputs.creditProduct.forEach((field) => {
            const { key, visibleForLoanTypes } = field;
            if (alwaysRequiredFields.includes(key)) return;
            if (!visibleForLoanTypes.includes(selectedLoanType)) return;
            if (!this.shouldRenderField(key)) return;

            const value = this.state.creditProduct[key];

            if (key === "accountNumber") {

                const isEmpty = value === undefined || value === null || value === "" || (typeof value === "string" && value.trim() === "");
                if (isEmpty) {
                    errors.push(key);
                } else if (value.length <= 6 || value.length >= 30) {
                    errors.push(key);
                    errorMessages = Strings("accountNumberNotValid");
                }
            } else {
                const isEmpty = value === undefined || value === null || value === "" || (typeof value === "string" && value.trim() === "");
                if (isEmpty) {
                    errors.push(key);
                }
            }
        });

        this.setState({
            errorFieldArray: errors,
            errorMessage: errorMessages,
        });
        if (errors.length === 0) {
            this.createLoan();
        }
    };
    renderErrors = () => {
        return (
            <>
                {this.state.errorMessage && (
                    <Col
                        md={12}
                        className='errors ps-4 mb-2'
                    >
                        {this.state.errorMessage}
                    </Col>
                )}
            </>
        )
    }

    isLoadedLoanAlreadyDisbursed = () => (
        this.props.applyLoanConfig?.loanStatus === LOAN_APPLICATION_STATUS.disbursed
        && this.props.loanInfo?.ilaff === LOAN_APPLICATION_FORM_FILLED
    );

    renderButton = () => {
        const isLoadedLoanAlreadyDisbursed = this.isLoadedLoanAlreadyDisbursed();

        return (
            <Row className='modalButton justify-content-between'>
                <Col md={2} className='text-start'>
                    <Button
                        className='buttonBorder me-4'
                        onClick={this.props.goBack}
                        disabled={this.props.showLoadingModalState}
                    >
                        {Strings("Back").toUpperCase()}
                    </Button>

                </Col>
                <Col md={4} className='d-flex justify-content-end pe-4'>
                    <Button
                        className='buttonBorder me-4'
                        onClick={this.props.goNext}
                        title={isLoadedLoanAlreadyDisbursed ? Strings("lastLoanAlreadyDisbursedWarning") : ""}
                        disabled={(!(this.props.loanInfo?.prefillData || this.props.basicInfo?.prefillData)) || this.props.showLoadingModalState || isLoadedLoanAlreadyDisbursed}
                    >
                        {Strings("Next").toUpperCase()}
                    </Button>
                    {!(this.props.disableTextField || this.props.applyLoanConfig.loanStatus === LOAN_APPLICATION_STATUS.created) && <Button
                        className={
                            "buttonBackground"
                        }
                        onClick={this.validateData}
                        disabled={this.props.showLoadingModalState}
                    >
                        {Strings("saveAndProceed")}
                    </Button>}
                </Col>
            </Row>
        )
    }
    renderLoanInfo = () => {
        let selectedRecordLabel = "";
        if (this.props.selectedLoanType === LOAN_TYPES.FACTORING) {
            selectedRecordLabel = Strings("Invoice");
        } else if (this.props.selectedLoanType === LOAN_TYPES.CONSUMER) {
            selectedRecordLabel = Strings("Product");
        } else if (this.props.selectedLoanType === LOAN_TYPES.MOTORCYCLE_LOAN) {
            selectedRecordLabel = Strings("Motorcycle");
        }
        return (
            <Col md={12} className="ps-4">
                <Row className="p-0">
                    <Col md={4} className="ps-0">
                        <span className="createLoanSubHeadingText ">
                            {Strings("loanOf") + Strings(this.props.selectedLoanType)}
                        </span>
                    </Col>
                    {selectedRecordLabel !== "" && <Col md={4} className="ps-1">
                        <span className="createLoanSubHeadingText ">
                            {Strings(selectedRecordLabel)} &nbsp;:
                        </span>
                        <span className="subHeaderApplication mb-0">
                            &nbsp; {this.props.selectedRecordData}
                        </span>
                    </Col>}
                    <Col md={4} className="ps-1">
                        <span className="createLoanSubHeadingText">
                            {Strings("suggestedAmount")} &nbsp;:
                        </span>
                        <span className="subHeaderApplication mb-0">
                            &nbsp; {this.props.suggestedAmount ? "$" + Utility.getCurrencyRepresentationOfAmount(this.props.suggestedAmount) : Strings("NA")}
                        </span>
                    </Col>
                </Row>
                <hr className="opacity-100 mb-2 me-2" />
            </Col>
        )
    }
    render() {
        return (
            <>
                {this.state.errorMessage && this.renderErrors()}
                {this.renderLoanInfo()}
                <Row>
                    {this.renderCreditProducts()}
                </Row>
                <Col md={12}>
                    <hr className="opacity-100 mt-2 ms-2 me-2 " />
                </Col>
                <Row>
                    <Col md={12}>
                        {this.renderCalculatedEMI()}
                    </Col>
                </Row>
                <Col md={12} className="pt-2">
                    <hr className="opacity-100 mb-2 ms-2 me-2" />
                </Col>
                {this.renderButton()}
            </>
        )
    }
}
export default CreditProduct;